import api from './api';

export async function listTegmTrimesters() {
  const { data } = await api.get('/gtl-tegm/serie-storica/trimesters');
  return data;
}

export async function listTegmYears() {
  const { data } = await api.get('/gtl-tegm/serie-storica/years');
  return data;
}

export async function listTegmSerieStorica({ data_inizio_trimestre, search = '' }) {
  const { data } = await api.get('/gtl-tegm/serie-storica', {
    params: {
      data_inizio_trimestre,
      search
    }
  });
  return data;
}

export async function createTegmSerieStorica(payload) {
  const { data } = await api.post('/gtl-tegm/serie-storica', payload);
  return data;
}

export async function updateTegmSerieStorica(id, payload) {
  const { data } = await api.put(`/gtl-tegm/serie-storica/${id}`, payload);
  return data;
}

export async function deleteTegmSerieStorica(id) {
  const { data } = await api.delete(`/gtl-tegm/serie-storica/${id}`);
  return data;
}

export async function importTegmSerieStoricaCsv(file) {
  const formData = new FormData();
  formData.append('file', file);
  const { data } = await api.post('/gtl-tegm/serie-storica/import-csv', formData);
  return data;
}

export async function downloadTegmSerieStoricaReportPdf({
  data_inizio_trimestre,
  search = '',
  reference_from = '',
  reference_to = ''
}) {
  return api.get('/gtl-tegm/serie-storica/report-pdf', {
    params: {
      data_inizio_trimestre,
      search,
      reference_from,
      reference_to
    },
    responseType: 'blob'
  });
}

export async function listIndicatoriTrimesters() {
  const { data } = await api.get('/gtl-tegm/indicatori/trimesters');
  return data;
}

export async function listIndicatoriYears() {
  const { data } = await api.get('/gtl-tegm/indicatori/years');
  return data;
}

export async function listIndicatori({ data_inizio_trimestre = '', search = '', from = '', to = '' }) {
  const { data } = await api.get('/gtl-tegm/indicatori', {
    params: {
      data_inizio_trimestre,
      search,
      from,
      to
    }
  });
  return data;
}

export async function createIndicatori(payload) {
  const { data } = await api.post('/gtl-tegm/indicatori', payload);
  return data;
}

export async function updateIndicatori(id, payload) {
  const { data } = await api.put(`/gtl-tegm/indicatori/${id}`, payload);
  return data;
}

export async function deleteIndicatori(id) {
  const { data } = await api.delete(`/gtl-tegm/indicatori/${id}`);
  return data;
}

export async function importIndicatoriCsv(file) {
  const formData = new FormData();
  formData.append('file', file);
  const { data } = await api.post('/gtl-tegm/indicatori/import-csv', formData);
  return data;
}

export async function downloadIndicatoriReportPdf({
  data_inizio_trimestre = '',
  search = '',
  reference_from = '',
  reference_to = ''
}) {
  return api.get('/gtl-tegm/indicatori/report-pdf', {
    params: {
      data_inizio_trimestre,
      search,
      reference_from,
      reference_to
    },
    responseType: 'blob'
  });
}
